import { ArrowForward } from "@mui/icons-material";
import { Button } from "antd";
import styled from "styled-components";
import { APP_URL, REGISTER_URL } from "../../../constants/constants";

export const Header = () => {
  return (
    <Wrapper id="home">
      <div className="flexCenter flexColumn">
        <TitleWrapper className="flexColumn textCenter">
          <h1
            className="bold secondary"
            data-aos="fade-up"
            data-aos-delay="500"
            data-aos-duration="1500"
          >
            Managing your Loan portfolio is now easier than sending{" "}
            <span className="main">Mobile Money</span>
          </h1>
          <div
            className="font13 grey"
            data-aos="fade-up"
            data-aos-delay="1000"
            data-aos-duration="1500"
          >
            Loan management software today are like a village rumor; details get
            lost so fast! <span className="main semiBold">Credtics.com</span>{" "}
            keeps every record safe and sound, just like a good bank vault.
            Track every loan—better than your mom keeping tabs on your WhatsApp
            last seen!
          </div>
          <div
            className="gap20 flexCenter"
            data-aos="fade-up"
            data-aos-delay="1500"
            data-aos-duration="1500"
          >
            <Button
              type="primary"
              style={{ width: 150 }}
              href={REGISTER_URL}
              target="_blank"
              icon={<ArrowForward style={{ fontSize: 15 }} />}
            >
              Get Started
            </Button>
            <Button style={{ width: 150 }} href={APP_URL} target="_blank">
              Login
            </Button>
          </div>
        </TitleWrapper>
      </div>
    </Wrapper>
  );
};

const TitleWrapper = styled.div`
  max-width: 600px;
  gap: 30px;

  @media (max-width: 960px) {
    padding: 0 15px;
  }
`;
const Wrapper = styled.div`
  padding-top: 80px;
  padding-bottom: 60px;
  @media (max-width: 960px) {
    padding-bottom: 40px;
  }
`;
